export const COLOR = {
  //main color
  brand: '#55BC7E',
  brand1: '#ECFFF3',
  brand2: '#CFFAE0',
  brand3: '#87DFAA',
  brand4: '#3FA066',
  brand5: '#14743A',

  //sub color
  red80: '#F2373E',
  red10: '#FFDDDD',
  green: '#00A256',
  blue: '#00A3FF',

  //gray
  black100: '#000000',
  black90: '#1A1A1A',
  black80: '#333333',
  black70: '#4D4D4D',
  black60: '#666666',
  black50: '#808080',
  black40: '#999999',
  black30: '#B3B3B3',
  black20: '#CCCCCC',
  black10: '#E6E6E6',
  black8: '#EBEBEB',
  black6: '#F0F0F0',
  black4: '#F5F5F5',
  black2: '#FAFAFA',
  white: '#FFFFFF',

  //blue gray
  bluegray80: '#282D3C',
  bluegray70: '#3C4160',
  bluegray50: '#646978',
  bluegray30: '#8C91A0',
  bluegray20: '#C8CDDC',
  bluegray10: '#F0F5FF',

  blackOpacity01: 'rgba(0, 0, 0, 0.1)',
  blackOpacity06: 'rgba(0, 0, 0, 0.6)',
  blackOpacity07: 'rgba(0, 0, 0, 0.7)',
  CameraDisabledSvg: '#828282',
}
